// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/vendor.scss
// module id = 274
// module chunks = 97